import { Meetings } from '@/components';

const MeetingsRoute = () => <Meetings />;

export default MeetingsRoute;
